<template>
  <div class="result">
    <div class="title">北京柯斯元纹理K防伪纸板</div>
    <h1>价格计算结果</h1>
    <div class="price"><span style="font-size: 28px;">{{ result }}</span> 元/个</div>
    <div class="button">
      <input type="button" @click="back" value="返 回" />
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      result: 100
    }
  },
  created () {
    this.result = this.$route.query.count
  },
  methods: {
    back () {
      this.$router.push('/quotation')
    }
  }
}
</script>
<style lang="scss" scoped>
.result {
  padding: 0.32rem;
  .title,
  h1,
  .button {
    text-align: center;
  }
  h1 {
    font-size: 0.64rem;
    line-height: 1.2rem;
  }
  .price {
    text-align: center;
    font-size: 0.48rem;
    line-height: 100px;
  }
  .button {
    padding: 16px 0;
    position: fixed;
    bottom: 0;
    height: 50px;
    line-height: 50px;
    width: 100%;
    text-align: center;
  }
  .tip {
    line-height: 0.5rem;
  }
  input{
    padding: 8px;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/quotation/result.vue